import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import {CONSTS} from './_constants';
// import $ from "jquery";

const Notif = ({type="info", children, timeout=3000, className, title}) => {
    const [active, setActive] = useState(false);
    window.setTimeout( () => {
        setActive(true);
        
    }, 0)
    return (
        <div className={`${className} ${active ? "active" : ""}`}>
            <div className="_icon">A</div>
            <div className="_body">
                <h4 className="_title">{title}</h4>
                { children && 
                    <p className="_text">
                        {children}
                    </p>
                }
            </div>
            <span className="_close">x</span>
        </div>
    )
}

const StyledNotif = styled(Notif)`
    position: fixed;
    right: 49px;
    bottom: ${props => 49 + props.bottom}px;
    z-index: 900;
    width: 340px;
    background: rgba(139, 153, 187, 1);
    padding: 17px;
    display: flex;
    justify-content: flex-start;
    border-radius: ${CONSTS.border.radius};
    color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(139, 153, 187, 0.3);
    transition: opacity .2s, transform .3s;
    opacity: 0;
    transform: translateY(100%);
    pointer-events: none;
    &.active{
        opacity: 1;
        transform: translateY(0);
        pointer-events: all;
    }
    ._icon{
        width: 17px;
    }
    ._body{
        padding: 0 17px;
        text-align: left;
        ._title{
            margin: 0;
        }
        ._text{
            margin: 10px 0 5px;
        }
    }
    ._close{
        position: absolute;
        right: 17px;
        top: 17px;
        cursor: pointer;
    }
`;

export const notify = {
    info : (title, message="") => {
        // var bottom = 0;
        // var $el = $(".sn_notif > div").last();
        // if($el.length > 0){
        //     var bottom = $(window).height() - $el.position().top - 29; 
        // }
        
        // let notif = 
        //     <StyledNotif title={title} bottom={bottom}>
        //         {message}
        //     </StyledNotif>;
        
        // var rand = parseInt(Math.random() * 10000);
        // var className = `notification_${rand}`;
        // $("body").append(`<div class="${className} sn_notif"></div>`);
        // var $node = $(`.${className}`);
        // var node = $node[0];
        // ReactDOM.render(notif, node);
        // window.setTimeout( () => {
        //     $node.removeClass("sn_notif")
        //      .find(".active").removeClass("active");
        //     window.setTimeout(() => {
        //         $node.remove();
        //     }, 500)
            
        // }, 2000)
    },
    test : (text) => {
        alert(text);
    }
};


export default StyledNotif;